module.exports = __webpack_public_path__ + "media/images/clients/disbursement_failure-3a4c2b99808e084d16632554203c6524.svg";